import { getFeatureData } from 'config-request';
import { CategoryCode, FeatureType, SubCategoryCode, } from 'config-request/src/interfaces/feature-list';
import { defineStore } from 'pinia';
import { useFeatureListStore } from './feature-list';
import { useGlobalStore } from './global';
import { usePriceListStore } from './price-list';
export const useColorStore = defineStore('color-store', {
    getters: {
        colorList() {
            const featureList = useFeatureListStore();
            const colorCodeList = [
                CategoryCode.Exterior,
                SubCategoryCode.Color,
                FeatureType.ExteriorColor,
            ];
            if (!featureList.data)
                return {
                    options: [],
                    optionCodes: [],
                };
            const featureItem = getFeatureData(colorCodeList, featureList.data);
            const options = featureItem?.option_list?.map((option) => featureList.data?.option_map[option]);
            return {
                options,
                optionCodes: featureItem?.option_list,
            };
        },
        currentColor() {
            const global = useGlobalStore();
            const featureList = useFeatureListStore();
            const priceList = usePriceListStore();
            if (!featureList.data)
                return null;
            const optionData = featureList.data.option_map[global.currentOptions.F00002];
            const priceDiscountTip = priceList.data?.configurator_select_discount_tip_map?.[global.currentOptions.F00002] || '';
            const priceDiscountTipIcon = priceList.data?.configurator_select_discount_tip_icon_map?.[global.currentOptions.F00002];
            const discountData = {
                discount_selected: !!priceDiscountTip,
                discount_tip: priceDiscountTip || optionData?.discount_tip || '',
                discount_tip_icon: priceDiscountTipIcon?.icon || optionData?.discount_tip_icon || '',
                discount_tip_icon_ratio: priceDiscountTipIcon?.icon_ratio || optionData?.discount_tip_icon_ratio || 0,
            };
            return {
                ...optionData,
                ...discountData,
            };
        },
    },
});
